<template>
  <div>
    <ButtonExport style="display:inline-block;"/>
    <ButtonDiaporama style="display:inline-block;"/>
    <ButtonsPieBar style="display:inline-block;"/>
    <ButtonFullScreen v-if="!this.$store.getters.iframeColidee && !viewColidee" style="display:inline-block;"/>
    <ButtonLanguages style="display:inline-block;"
        v-if="this.$store.getters.sondage_languages.length > 1 || this.$store.state.sondage.languagesAdmin.length > 1"
    />
  </div>
</template>

<script>
import ButtonLanguages from '@/components/question/components/ButtonLanguages'
import ButtonFullScreen from '@/components/resultats/components/ButtonFullScreen'
import ButtonsPieBar from '@/components/resultats/components/ButtonsPieBar'
import ButtonDiaporama from '@/components/resultats/components/ButtonDiaporama'
import ButtonExport from '@/components/resultats/components/ButtonExport'
export default {
  name: 'HeaderResulats',
  props: {
    viewColidee: {
      required: false
    }
  },
  components: {
    ButtonExport,
    ButtonLanguages,
    ButtonFullScreen,
    ButtonsPieBar,
    ButtonDiaporama
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/Buttons.vue